import { observer } from 'mobx-react'
import { TableCell } from 'components/Table'
import styles from './ServiceCell.sass'
import React from 'react'

interface ServiceCellProps {
  children: string
}

export default observer(function ServiceCell({ children }: ServiceCellProps) {
  return (
    <TableCell>
      <div className={styles.service}>{children}</div>
    </TableCell>
  )
})
